import { API, generic } from "api"

export default class OrganizationsService {
  static me = async ({ pageState }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_ORGANIZATIONS_ME_STATUS",
      stateDataKey: ["organization"],
      stateErrorKey: ["organizationErrors"],
      apiEndpoint: API.users.organizations.me,
      apiUrlReplacements: {},
      apiData: {},
      errorMessage: "Organization data could not be fetched.",
    })
  }

  static uploadLogo = async ({ pageState, formData }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_ORGANIZATIONS_UPLOAD_LOGO_STATUS",
      stateDataKey: ["organization"],
      stateErrorKey: ["organizationErrors"],
      apiEndpoint: API.users.organizations.uploadLogo,
      apiUrlReplacements: {},
      apiData: formData,
      errorMessage: "Organization logo could not be uploaded.",
    })
  }

  static templateVariable = async ({ pageState }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_ORGANIZATIONS_TEMPLATE_VARIABLE_STATUS",
      stateDataKey: ["unserialized"],
      stateErrorKey: ["unserializedErrors"],
      apiEndpoint: API.users.organizations.templateVariable,
      apiUrlReplacements: {},
      apiData: {},
      errorMessage: "Organization template variable could not be fetched.",
      serializedResponse: false,
    })
  }

  static update = async ({ pageState, id, values }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_ORGANIZATIONS_UPDATE_STATUS",
      stateDataKey: ["organization"],
      stateErrorKey: ["organizationErrors"],
      apiEndpoint: API.users.organizations.update,
      apiUrlReplacements: {id},
      apiData: {...values},
      errorMessage: "Organization data could not be fetched.",
    })
  }

  static updateOfferLetterAlignment = async ({ pageState, offerLetterTemplateIds }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_ORGANIZATIONS_UPDATE_OFFER_LETTER_ALIGNMENT_STATUS",
      stateDataKey: ["offer_letter_alignment_ids"],
      stateErrorKey: ["offerLetterAlignmentIdsErrors"],
      apiEndpoint: API.users.organizations.updateOfferLetterAlignment,
      apiUrlReplacements: {},
      apiData: { offer_letter_template_ids: offerLetterTemplateIds },
      errorMessage: "Offer letter alignment could not be updated.",
      serializedResponse: false,
    })
  }

  static updateAdditionalLetterAlignment = async ({ pageState, additionalLetterTemplateIds }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_ORGANIZATIONS_UPDATE_ADDITIONAL_LETTER_ALIGNMENT_STATUS",
      stateDataKey: ["additional_letter_alignment_ids"],
      stateErrorKey: ["additionalLetterAlignmentIdsErrors"],
      apiEndpoint: API.users.organizations.updateAdditionalLetterAlignment,
      apiUrlReplacements: {},
      apiData: { additional_letter_template_ids: additionalLetterTemplateIds },
      errorMessage: "Additional letter alignment could not be updated.",
      serializedResponse: false,
    })
  }

  static letterAlignmentConfigLists = async ({ pageState }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_ORGANIZATIONS_LETTER_ALIGNMENT_CONFIG_LISTS_STATUS",
      stateDataKey: ["letter_alignment_config"],
      stateErrorKey: ["letterAlignmentConfigErrors"],
      apiEndpoint: API.users.organizations.letterAlignmentConfigLists,
      apiUrlReplacements: {},
      apiData: {},
      errorMessage: "Letter alignment config could not be fetched.",
      serializedResponse: false,
    })
  }
}
